(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mdb-ui-kit-generator-api", [], factory);
	else if(typeof exports === 'object')
		exports["mdb-ui-kit-generator-api"] = factory();
	else
		root["mdb-ui-kit-generator-api"] = factory();
})(this, function() {
return 